<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="180.221"
    height="48.8"
    viewBox="0 0 180.221 48.8"
  >
    <g id="SCE_logo" data-name="SCE logo" transform="translate(83.034 22.5)">
      <g id="Group_6" data-name="Group 6" transform="translate(-83.035 -22.5)">
        <rect
          id="Rectangle_3"
          data-name="Rectangle 3"
          width="48.725"
          height="48.775"
          fill="#fff"
        />
        <g id="Group_1" data-name="Group 1">
          <path
            id="Path_1"
            data-name="Path 1"
            d="M.03,29.885l20.353,1.726L5.461,20.689l17.11,6.242L6.116,6.092,26.948,22.433,20.689,5.46,31.08,19.881,30.155.023l6.517,19.918L41.527,0H0V41.527H.017L20.139,37.02Z"
            fill="#1a1818"
          />
          <path
            id="Path_2"
            data-name="Path 2"
            d="M0,41.553H41.527V0h7.2V48.8H0Z"
            fill="#1a1818"
          />
        </g>
        <path
          id="Path_3"
          data-name="Path 3"
          d="M163.979,23.541a2.475,2.475,0,1,0-2.475-2.475A2.476,2.476,0,0,0,163.979,23.541Z"
          transform="translate(13.642 1.57)"
          fill="none"
          stroke="#1a1818"
          stroke-width="0.25"
        />
        <path
          id="Path_4"
          data-name="Path 4"
          d="M163.437,19.608c0-.1.023-.105.162-.105.81,0,.906.4.906.782,0,.28-.117.729-.862.729-.074,0-.149,0-.2-.009Zm-.788,2.871c.2-.012.4-.023.585-.023.153,0,.356.011.552.023v-.1h-.105c-.2,0-.243-.044-.243-.27v-.964c.359,0,.368.026.529.234l.844,1.1a3.31,3.31,0,0,1,.346-.023,3.479,3.479,0,0,1,.357.023v-.1c-.175-.014-.26-.031-.434-.258l-.617-.8a1.649,1.649,0,0,0-.257-.259.865.865,0,0,0,.773-.855c0-.677-.512-.852-1.081-.852-.2,0-.4.024-.664.024-.187,0-.389-.012-.585-.024v.1h.1c.194,0,.242.042.242.269v2.384c0,.226-.048.27-.242.27h-.1Z"
          transform="translate(13.738 1.634)"
          fill="#1a1818"
        />
        <g id="Group_5" data-name="Group 5" transform="translate(59.962 7.547)">
          <g id="Group_4" data-name="Group 4">
            <g id="Group_2" data-name="Group 2" transform="translate(0.111 11.911)">
              <path
                id="Path_5"
                data-name="Path 5"
                d="M55.394,40.31V18.5h12.89v1.414H59.5v8.413h8.279v1.413H59.5V38.9h8.919V40.31Z"
                transform="translate(-55.394 -17.895)"
                fill="#1a1818"
              />
              <path
                id="Path_6"
                data-name="Path 6"
                d="M72.384,18.5h7.1c7.875,0,11.61,5.586,11.61,11.31,0,6.966-4.476,10.5-10.837,10.5H72.384Zm4.1,20.4h2.558c6.563,0,7.944-4.746,7.944-9.02,0-5.486-2.558-9.962-7.742-9.962h-2.76Z"
                transform="translate(-53.959 -17.895)"
                fill="#1a1818"
              />
              <path
                id="Path_7"
                data-name="Path 7"
                d="M94.336,40.31V18.5h4.106V40.31Z"
                transform="translate(-52.105 -17.895)"
                fill="#1a1818"
              />
              <path
                id="Path_8"
                data-name="Path 8"
                d="M105.252,36.454c1.145,1.816,2.357,2.792,4.51,2.792a3.9,3.9,0,0,0,3.9-3.77c0-6.328-10.231-3.331-10.231-11.14,0-3.5,2.928-6.4,7-6.4a7.3,7.3,0,0,1,6.563,3.9l-1.413.91a4.754,4.754,0,0,0-4.477-3.1,3.527,3.527,0,0,0-3.567,3.8c0,5.115,10.231,2.962,10.231,10.837,0,4-3.5,6.664-7.168,6.664-2.963,0-5.352-.875-6.867-3.4Z"
                transform="translate(-51.336 -17.942)"
                fill="#1a1818"
              />
              <path
                id="Path_9"
                data-name="Path 9"
                d="M130.846,17.942c6.328,0,10.837,5.083,10.837,11.511s-4.509,11.511-10.837,11.511c-6.294,0-10.8-5.082-10.8-11.511S124.552,17.942,130.846,17.942Zm0,21.608c5.251,0,6.429-5.857,6.429-10.1s-1.178-10.1-6.429-10.1-6.4,5.855-6.4,10.1S125.6,39.55,130.846,39.55Z"
                transform="translate(-49.933 -17.942)"
                fill="#1a1818"
              />
              <path
                id="Path_10"
                data-name="Path 10"
                d="M144.292,40.31V18.5h3.669l11.408,15.011h.068V18.5h1.749V40.31h-1.818l-13.259-17.4h-.068v17.4Z"
                transform="translate(-47.885 -17.895)"
                fill="#1a1818"
              />
            </g>
            <g id="Group_3" data-name="Group 3">
              <path
                id="Path_11"
                data-name="Path 11"
                d="M55.886,13.007a1.6,1.6,0,0,0,1.474.913,1.273,1.273,0,0,0,1.275-1.232c0-2.067-3.343-1.089-3.343-3.639a2.16,2.16,0,0,1,2.287-2.09,2.383,2.383,0,0,1,2.144,1.275l-.461.3A1.554,1.554,0,0,0,57.8,7.521a1.152,1.152,0,0,0-1.166,1.242c0,1.671,3.343.968,3.343,3.541a2.254,2.254,0,0,1-2.342,2.178,2.379,2.379,0,0,1-2.244-1.11Z"
                transform="translate(-55.292 -6.959)"
                fill="#1a1818"
              />
              <path
                id="Path_12"
                data-name="Path 12"
                d="M63.962,6.959A3.572,3.572,0,0,1,67.5,10.72a3.542,3.542,0,1,1-7.071,0A3.569,3.569,0,0,1,63.962,6.959Zm0,7.061c1.717,0,2.1-1.915,2.1-3.3s-.385-3.3-2.1-3.3-2.088,1.912-2.088,3.3S62.247,14.02,63.962,14.02Z"
                transform="translate(-54.858 -6.959)"
                fill="#1a1818"
              />
              <path
                id="Path_13"
                data-name="Path 13"
                d="M69.43,7.142v5.09a1.508,1.508,0,0,0,1.518,1.507c.627,0,1.716-.22,1.716-1.441V7.142h.572v5.323c0,.913-.693,2-2.5,2-1.177,0-2.65-.451-2.65-2.264V7.142Z"
                transform="translate(-54.211 -6.944)"
                fill="#1a1818"
              />
              <path
                id="Path_14"
                data-name="Path 14"
                d="M75.318,14.267V7.6H73.9V7.142h4.178V7.6H76.66v6.664Z"
                transform="translate(-53.72 -6.944)"
                fill="#1a1818"
              />
              <path
                id="Path_15"
                data-name="Path 15"
                d="M78.8,14.267V7.142H80.14v3.133h2.925V7.142h1.343v7.125H83.065v-3.43H80.14v3.43Z"
                transform="translate(-53.306 -6.944)"
                fill="#1a1818"
              />
              <path
                id="Path_16"
                data-name="Path 16"
                d="M85.625,14.267V7.142h4.212V7.6H86.966v2.75h2.706v.461H86.966v2.992H89.88v.461Z"
                transform="translate(-52.73 -6.944)"
                fill="#1a1818"
              />
              <path
                id="Path_17"
                data-name="Path 17"
                d="M90.85,14.267V7.142h3.078a1.965,1.965,0,0,1,2.024,2.1c0,1.089-.792,1.563-1.858,1.694l1.891,3.331H94.511l-1.947-3.65h.089c1.186,0,1.956-.462,1.956-1.529a1.486,1.486,0,0,0-1.693-1.593h-.726v6.772Z"
                transform="translate(-52.289 -6.944)"
                fill="#1a1818"
              />
              <path
                id="Path_18"
                data-name="Path 18"
                d="M96.731,14.267V7.142h1.2l3.727,4.9h.022v-4.9h.572v7.125h-.593L97.324,8.582H97.3v5.685Z"
                transform="translate(-51.792 -6.944)"
                fill="#1a1818"
              />
              <path
                id="Path_19"
                data-name="Path 19"
                d="M112.908,8.719a2.625,2.625,0,0,0-2.056-1.3c-1.737,0-2.618,1.274-2.618,3.331,0,1.605.813,3.167,2.453,3.167a2.564,2.564,0,0,0,2.363-1.562l.474.23a3.181,3.181,0,0,1-3.1,1.892,3.67,3.67,0,0,1-3.629-3.672,3.706,3.706,0,0,1,3.76-3.85,3.391,3.391,0,0,1,2.75,1.473Z"
                transform="translate(-50.942 -6.959)"
                fill="#1a1818"
              />
              <path
                id="Path_20"
                data-name="Path 20"
                d="M119.072,14.282H117.7l-.758-1.859h-2.452l-.715,1.859h-.628l2.9-7.323h.024Zm-3.364-4.938-1.035,2.618h2.08Z"
                transform="translate(-50.405 -6.959)"
                fill="#1a1818"
              />
              <path
                id="Path_21"
                data-name="Path 21"
                d="M119.535,14.267V7.142h1.34v6.564h2.861v.561Z"
                transform="translate(-49.866 -6.944)"
                fill="#1a1818"
              />
              <path
                id="Path_22"
                data-name="Path 22"
                d="M124.392,14.267V7.142h1.343v7.125Z"
                transform="translate(-49.455 -6.944)"
                fill="#1a1818"
              />
              <path
                id="Path_23"
                data-name="Path 23"
                d="M127.413,14.267V7.142H131.5V7.6h-2.75v2.75h2.508v.461h-2.508v3.453Z"
                transform="translate(-49.2 -6.944)"
                fill="#1a1818"
              />
              <path
                id="Path_24"
                data-name="Path 24"
                d="M135.263,6.959A3.573,3.573,0,0,1,138.8,10.72a3.543,3.543,0,1,1-7.072,0A3.57,3.57,0,0,1,135.263,6.959Zm0,7.061c1.716,0,2.1-1.915,2.1-3.3s-.386-3.3-2.1-3.3-2.089,1.912-2.089,3.3S133.548,14.02,135.263,14.02Z"
                transform="translate(-48.835 -6.959)"
                fill="#1a1818"
              />
              <path
                id="Path_25"
                data-name="Path 25"
                d="M139.388,14.267V7.142h3.08a1.964,1.964,0,0,1,2.023,2.1c0,1.089-.793,1.563-1.858,1.694l1.891,3.331H143.05l-1.947-3.65h.088c1.186,0,1.957-.462,1.957-1.529a1.486,1.486,0,0,0-1.694-1.593h-.726v6.772Z"
                transform="translate(-48.189 -6.944)"
                fill="#1a1818"
              />
              <path
                id="Path_26"
                data-name="Path 26"
                d="M145.27,14.267V7.142h1.2l3.727,4.9h.022v-4.9h.572v7.125H150.2l-4.332-5.685h-.022v5.685Z"
                transform="translate(-47.692 -6.944)"
                fill="#1a1818"
              />
              <path
                id="Path_27"
                data-name="Path 27"
                d="M152.1,14.267V7.142h1.34v7.125Z"
                transform="translate(-47.115 -6.944)"
                fill="#1a1818"
              />
              <path
                id="Path_28"
                data-name="Path 28"
                d="M160.335,14.282h-1.374l-.759-1.859H155.75l-.716,1.859h-.627l2.9-7.323h.021ZM156.97,9.345l-1.033,2.618h2.078Z"
                transform="translate(-46.92 -6.959)"
                fill="#1a1818"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>
